@switch (context ? context.type : '') {
    @default {
        <fui-edit-color-pair-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                                   [label]="label" [labelI18NParams]="labelI18NParams" [placeholder]="placeholder"
                                   (focussed$)="onFocussed($event)" [notation]="notation"
                                   [backgroundEditable]="backgroundEditable"
                                   [foregroundEditable]="foregroundEditable"
                                   [allowBackgroundAlpha]="allowBackgroundAlpha"
                                   [allowForegroundAlpha]="allowForegroundAlpha"
                                   [showClearIcon]="showClearIcon" (onClear)="onClear.next()"
                                   [(backgroundSelected)]="inputBackgroundSelected"
                                   [okLabel]="okLabel" [resetLabel]="resetLabel">
        </fui-edit-color-pair-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-color-pair-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                                     [placeholder]="placeholder"
                                     (focussed$)="onFocussed($event)"
                                     [notation]="notation"
                                     [backgroundEditable]="backgroundEditable"
                                     [foregroundEditable]="foregroundEditable"
                                     [allowBackgroundAlpha]="allowBackgroundAlpha"
                                     [allowForegroundAlpha]="allowForegroundAlpha"
                                     [showClearIcon]="showClearIcon" (onClear)="onClear.next()"
                                     [(backgroundSelected)]="inputBackgroundSelected"
                                     [okLabel]="okLabel" [resetLabel]="resetLabel">
        </fui-inline-color-pair-input>
    }
}
